export const returnInputHandlers = (type: string, schema) => {
    const additionalProperties = {};
    if (type === "number") {
        additionalProperties["min"] = schema.const.minimum;
        additionalProperties["max"] = schema.const.maximum;
        // additionalProperties['onKeyUp']=handleKeyUp
    }
    return additionalProperties;
};
